import { useEffect } from 'react';

const SEO = ({ title, description }) => {
  useEffect(() => {
    // 타이틀 설정
    if (title) {
      document.title = title;
    }

    // 메타 설명 설정
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        // 메타 태그가 없으면 새로 생성
        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = description;
        document.head.appendChild(meta);
      }
    }
  }, [title, description]);

  return null;
};

export default SEO; 